var cardBlockStories = (function () {
  var paramsValue = {}, queryStringUTM = "";

  //init function
  function init() {
    uiBindings();
   
    //var declaration
    var caseStudyIndustry = document.getElementById("caseStudyIndustry"),
      caseStudyProducts = document.getElementById("caseStudyProducts"),
      caseStudySearch = document.getElementById("caseStudySearch"),
      clearCaseStudyFilter = document.getElementById("clearCaseStudyFilter"),
      showMoreBtn = document.querySelector(".btn-stories-show-more");

    var whiteListParams = [
      'utm_source',
      'utm_medium',
      'utm_platform',
      'utm_content',
      'utm_campaign',
      'utm_campaigncode',
      'utm_term'
    ],
      paramsObj = window.location.search
        .slice(1)
        .split('&')
        .map(function (p) {
          return p.split('=');
        })
        .reduce(function (obj, pair) {
          if (pair.length >= 2) {
            obj[pair[0]] = pair[1];
          }
          return obj;
        }, {});

    //Read from cookie
    if (Object.keys(paramsObj).length == 0) {
      var cookieUtmParams = Cookie.read(stage_env_cookie_prefix + "user_utm_data");
      if (cookieUtmParams) {
        paramsObj = bsLib.JSONParse(cookieUtmParams);
      }
    }

    // check white list params
    Object.keys(paramsObj).forEach(function (key) {
      if (whiteListParams.indexOf(key) > -1) {
        paramsValue[key] = paramsObj[key];
      }
    });

    //CS Industry DropDown
    if (caseStudyIndustry) {
      new ChosenCustom({
        selector: caseStudyIndustry,
        ID: "selectIndustry",
        placeholder: "Industry",
        search: true,
        searchPlaceholder: "Search Industry..."
      });

      caseStudyIndustry.addEventListener("change", function (evt) {
        var that = this,
          dataAjax = {
            perpage: showMoreBtn.dataset.perpage,
            offset: 0,
            industry: that.value,
            product: caseStudyProducts.value,
            q: caseStudySearch.value
          };

        storiesDataAjax(dataAjax);

        clearCaseStudyFilter.classList.remove("hide");

        //active
        that.closest(".stories-card-block__filter-dd").classList.add("active");

        paramsValue["cs-industry"] = that.value;
        paramsValue["cs-product"] = caseStudyProducts.value;
        paramsValue["cs-search"] = caseStudySearch.value;
        paramsValue["stories-page"] = 0;

        updateQueryStringParameter();
      });
    }

    //CS Products DropDown
    if (caseStudyProducts) {
      new ChosenCustom({
        selector: caseStudyProducts,
        ID: "selectProducts",
        placeholder: "Products",
        search: true,
        searchPlaceholder: "Search Product..."
      });

      caseStudyProducts.addEventListener("change", function (evt) {
        var that = this,
          dataAjax = {
            perpage: showMoreBtn.dataset.perpage,
            offset: 0,
            industry: caseStudyIndustry.value,
            product: that.value,
            q: caseStudySearch.value
          };

        storiesDataAjax(dataAjax);

        clearCaseStudyFilter.classList.remove("hide");

        //active
        that.closest(".stories-card-block__filter-dd").classList.add("active");

        paramsValue["cs-industry"] = caseStudyIndustry.value;
        paramsValue["cs-product"] = that.value;
        paramsValue["cs-search"] = caseStudySearch.value;
        paramsValue["stories-page"] = 0;

        updateQueryStringParameter();
      });
    }

    //CS Search
    if (caseStudySearch) {
      caseStudySearch.addEventListener(
        "keyup",
        function (evt) {
          var that = this,
            inputVal = that.value.trim();
          if (inputVal !== "" && inputVal.length) {
            caseStudySearch.classList.add("active");
          } else {
            caseStudySearch.classList.remove("active");
          }
        },
        false
      );

      // Execute a function when the user presses a key on the keyboard
      caseStudySearch.addEventListener(
        "keypress",
        function (evt) {
          // If the user presses the "Enter" key on the keyboard
          if (evt.key === "Enter") {
            evt.preventDefault();

            var that = this,
              dataAjax = {
                perpage: showMoreBtn.dataset.perpage,
                offset: 0,
                industry: caseStudyIndustry.value,
                product: caseStudyProducts.value,
                q: that.value.trim()
              };

            if (that.value.trim() === "" && window.location.href.indexOf("cs-search") > 0) {
              storiesDataAjax(dataAjax);
            } else if (that.value.trim() !== "") {
              storiesDataAjax(dataAjax);
            }

            if (that.value.trim() === "" && caseStudyIndustry.value === "" && caseStudyProducts.value === "") {
              clearCaseStudyFilter.classList.add("hide");
            } else {
              clearCaseStudyFilter.classList.remove("hide");
            }

            paramsValue["cs-industry"] = caseStudyIndustry.value;
            paramsValue["cs-product"] = caseStudyProducts.value;
            paramsValue["cs-search"] = that.value.trim();
            paramsValue["stories-page"] = 0;

            updateQueryStringParameter();
          }
        },
        false
      );
    }

    //CS Clear Button
    if (clearCaseStudyFilter) {
      clearCaseStudyFilter.addEventListener(
        "click",
        function (evt) {
          evt.preventDefault();

          var that = this,
            dataAjax = {
              perpage: showMoreBtn.dataset.perpage,
              offset: 0,
              industry: "",
              product: "",
              q: ""
            };

          storiesDataAjax(dataAjax);

          //remove active class
          caseStudyIndustry.closest(".stories-card-block__filter-dd").classList.remove("active");
          caseStudyProducts.closest(".stories-card-block__filter-dd").classList.remove("active");
          caseStudySearch.classList.remove("active");

          //chosen reset
          new ChosenCustom({
            selector: caseStudyIndustry,
            reset: true
          });

          new ChosenCustom({
            selector: caseStudyProducts,
            reset: true
          });

          //search reset
          caseStudySearch.value = "";

          that.classList.add("hide");

          delete paramsValue["cs-industry"];
          delete paramsValue["cs-product"];
          delete paramsValue["cs-name"];
          delete paramsValue["cs-search"];
          delete paramsValue["stories-page"];

          updateQueryStringParameter();
        },
        false
      );
    }

    //Pagination show more button
    if (showMoreBtn) {
      showMoreBtn.addEventListener(
        "click",
        function (evt) {
          evt.preventDefault();

          var that = this,
            dataAjax = {
              perpage: that.dataset.perpage,
              offset: that.dataset.offset,
              industry: caseStudyIndustry.value,
              product: caseStudyProducts.value,
              q: caseStudySearch.value.trim()
            };

          storiesDataAjax(dataAjax);

          paramsValue["cs-industry"] = caseStudyIndustry.value;
          paramsValue["cs-product"] = caseStudyProducts.value;
          paramsValue["cs-search"] = caseStudySearch.value.trim();
          paramsValue["stories-page"] = 0;

          updateQueryStringParameter();
        },
        false
      );
    }
  }

  function storiesDataAjax(dataAjax) {
    var pageBtn = document.querySelector(".btn-stories-show-more"),
      noResultsstories = document.getElementById("noResultsstories"),
      loaderContent = document.querySelector('.stories-card-block-loading-container');

    pageBtn.classList.add("visible-hide");
    noResultsstories.classList.add("hide");

    if (loaderContent) {
      loaderContent.classList.remove("hide");
    }

    bsLib.ajax(
      "POST",
      bsLib.railsHost() + "/wp-admin/admin-ajax.php",
      bsLib.extend({
        action: "bstack_stories_card_data",
        security: ajax_initialize_script.ajax_nonce
      },
        dataAjax
      ),
      true, //async	
      {
        "content-type": "application/x-www-form-urlencoded; charset=UTF-8"
      }, //request header	
      function (data) {
        if (data.readyState === 4) {
          var dataRequest = bsLib.JSONParse(data.response),
            storiesRow = document.querySelector(".stories-card-block .stories-card-block__row");

          if (dataRequest.status) {
            if (dataAjax.offset > 0) {
              storiesRow.insertAdjacentHTML('beforeend', dataRequest.html);
            } else {
              storiesRow.innerHTML = dataRequest.html;
            }

            pageBtn.dataset.offset = dataRequest.offset;

            if (loaderContent) {
              loaderContent.classList.add("hide");
            }

            if (dataRequest.filtered == 0) {
              noResultsstories.classList.remove("hide");
            }

            if (dataRequest.filtered < 3) {
              storiesRow.classList.add("stories-card-block__row--flex-start");
            } else {
              storiesRow.classList.remove("stories-card-block__row--flex-start");
            }

            if ((dataRequest.offset * dataAjax.perpage) < dataRequest.filtered) {
              pageBtn.classList.remove("visible-hide");
            }
            uiBindings();
            lazyLoading.show();
          }
        }
      }, //success	
      function () { } //error object	
    );
  }

  function uiBindings() {
    var modalOverlay = document.querySelectorAll(".stories-card-block__watch-video-btn");
    if (modalOverlay) {
      for (var i = 0; i < modalOverlay.length; i++) {
        var ua = navigator.userAgent.toLowerCase(),
          isSafari = false,
          sandboxFlag = '';

        // Detect browser for allow presentation sandbox flag
        try {
          isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || safari.pushNotification);
        }
        catch (err) { }
        isSafari = (isSafari || ((ua.indexOf('safari') != -1) && (!(ua.indexOf('chrome') != -1) && (ua.indexOf('version/') != -1))));
        sandboxFlag = isSafari ? '' : 'allow-presentation';

        modalOverlay[i].addEventListener("click", function (e) {
          e.preventDefault();
          var that = this,
            modalVideoId = that.getAttribute("data-video-id");

          if (modalVideoId) {
            var modalVideo = new tingle.modal({
              focusAfterClosed: that,
              closeIconInverse: true,
              cssClass: ['yt-modal'],
              onClose: function () {
                modalVideo.destroy();
              }
            });
            modalVideo.setContent(
              '<iframe width="100%" height="480" src="https://www.youtube.com/embed/' +
              modalVideoId +
              '?autoplay=1" frameborder="0" sandbox="allow-scripts allow-same-origin ' + sandboxFlag + '" allowfullscreen></iframe>'
            );
            modalVideo.open();
          }
        });
      }
    }
  }

  // Function to update Query String in the URL
  // https://jsfiddle.net/bp3tmuxh/1/
  function updateQueryStringParameter() {
    if (paramsValue.hasOwnProperty("cs-industry")) {
      if (paramsValue["cs-industry"] === "") {
        delete paramsValue["cs-industry"];
      }
    }

    if (paramsValue.hasOwnProperty("cs-product")) {
      if (paramsValue["cs-product"] === "") {
        delete paramsValue["cs-product"];
      }
    }

    if (paramsValue.hasOwnProperty("cs-name")) {
      if (paramsValue["cs-name"] === "") {
        delete paramsValue["cs-name"];
      }
    }

    if (paramsValue.hasOwnProperty("cs-search")) {
      if (paramsValue["cs-search"] === "") {
        delete paramsValue["cs-search"];
      }
    }

    if (paramsValue.hasOwnProperty("stories-page")) {
      if (paramsValue["stories-page"] === 0) {
        delete paramsValue["stories-page"];
      }
    }

    if (Object.keys(paramsValue).length > 0) {
      queryStringUTM = "?" + Object.keys(paramsValue).map(function (key) {
        return key + '=' + paramsValue[key]
      }).join('&');
    } else {
      queryStringUTM = "";
    }

    var uri = window.location.href.split('?')[0];

    if (history.pushState) {
      var hash = "";
      if (uri.indexOf("#") !== -1) {
        hash = uri.replace(/.*#/, "#");
        uri = uri.replace(/#.*/, "");
      }

      //update referrer
      var newReferrer = window.location.href;
      Object.defineProperty(document, "referrer", {
        configurable: true,
        get: function () {
          return newReferrer;
        }
      });

      window.history.pushState(
        { path: window.location.href },
        "",
        uri + queryStringUTM + hash
      );
    }
  }
  init();
})();